"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function removeCookie(key, config) {
    var cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    if (config) {
        cookie += config.domain ? "; domain=" + config.domain : '';
        cookie += config.path ? "; path=" + config.path : '';
    }
    document.cookie = cookie;
}
exports.removeCookie = removeCookie;
